import React from 'react'
import UnarchiveSvg from 'images/modules/Manage/i-unarchive.svg?raw'

export { default as UnarchiveUrl } from 'images/modules/Manage/i-unarchive.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: UnarchiveSvg}} />
)
